import IOrder from "../../../models/IOrder";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import { Link } from "react-router-dom";
import OwPill from "../../shared/OwPill/OwPill";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwBadge from "../../shared/OwBadge/OwBadge";
import QuoteStatusEnum from "../../../models/QuoteStatusEnum";
import OrderSourceEnum from "../../../models/OrderSourceEnum";
import IntegrationsConnectedBar from "../../shared/IntegrationsConnectedBar/IntegrationsConnectedBar";
import ITag from "../../../models/ITag";
import OwButton from "../../shared/OwButton/OwButton";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import { ReactElement } from "react";
import UserService from "../../../services/UserService";
import IOwTableCols from "../../../models/IOwTableCols";
import * as _ from "lodash-es";
import ISupplierSettings from "../../../models/ISupplierSettings";

const renderOrderNameFn = (options: {
    row: IOrder;
    getViewOrderUrl: (row: IOrder) => string;
    stepBeforeShippedOrderStateId: OrderStatesEnum | undefined;
    openShipmentSidebar: (row: IOrder) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
}): ReactElement => {
    let showIsRemake = false;

    if (options.row.is_remake) {
        if (!options.userModel.isSupplierUser && options.supplierModel.hide_remake_from_accounts) {
            showIsRemake = false;
        } else {
            showIsRemake = true;
        }
    }

    const toUrl = options.getViewOrderUrl(options.row);

    let showCreateShipmentBtn = options.row.order_state_id === options.stepBeforeShippedOrderStateId;

    if (options.supplierModel.guid !== SupplierGuidEnum.VERMONT) {
        showCreateShipmentBtn = false;
    }

    return (
        <div>
            <div className={"d-flex justify-content-start align-items-center"}>
                <div className={"text-nowrap"}>
                    <Link title={"Order Entry"} to={toUrl}>
                        {options.row.name}
                    </Link>
                    {options.row.approve_decline ? (
                        <span className={"ms-md-2"}>
                            <OwPill
                                title={options.row.approve_decline === "APPROVE" ? "approved" : "declined"}
                                className={"ps-2 pe-2 " + (options.row.approve_decline === "APPROVE" ? "bg-success" : "bg-danger")}
                            />
                        </span>
                    ) : null}
                    {options.supplierModel.has_purchase_orders &&
                    options.supplierModel.show_po_status_order_screen &&
                    options.userModel.isSupplierUser ? (
                        <div className={"text-small"}>
                            <div>
                                {options.row.has_po ? (
                                    <div>
                                        <OwLabel title={"has_po"} className={"text-success"} />
                                    </div>
                                ) : (
                                    <div>
                                        <OwLabel title={"no_po"} className={"text-danger"} />
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : null}
                    {options.row.fishbowl_so_id && options.row.fishbowl_so_id !== options.row.name ? (
                        <div className={"text-small text-muted"}>SO#: {options.row.fishbowl_so_id}</div>
                    ) : null}
                    {options.row.qbd_RefNumber && options.userModel.isSupplierUser && (
                        <div className={"text-small text-muted"}>
                            <OwLabel skipTranslate={true} title={"QBE SO#"} postText={":"} className={"me-2"} />
                            {options.row.qbd_RefNumber}
                        </div>
                    )}
                </div>

                {options.row.is_default_template ? <OwBadge title={"default"} bgColor={"bg-warning text-dark"} /> : null}
                {options.row.is_expedited ? <OwBadge title={"expedited"} bgColor={"bg-danger"} /> : null}
                {showIsRemake ? <OwBadge title={"remake"} bgColor={"bg-warning text-dark"} /> : null}
                {options.row.is_cancelled ? <OwBadge title={"cancelled"} bgColor={"bg-danger"} /> : null}
                {options.row.is_on_hold ? (
                    <OwBadge title={"on_hold"} bgColor={"bg-warning text-dark"} leftIconClass={"fas fa-pause"} />
                ) : null}
                {options.row.is_backorder ? <OwBadge title={"backorder"} bgColor={"bg-info"} leftIconClass={"fad fa-history"} /> : null}
                {options.row.is_local_pickup ? (
                    <OwBadge title={"local_pickup"} bgColor={"bg-secondary"} leftIconClass={"fad fa-hand-holding-box"} />
                ) : null}
                {options.row.is_local_delivery ? (
                    <OwBadge title={"local_delivery"} bgColor={"bg-warning text-dark"} leftIconClass={"fad fa-truck"} />
                ) : null}
                {options.row.is_dropship ? <OwBadge title={"is_dropship"} bgColor={"bg-warning text-dark"} /> : null}
                {options.row.is_consignment ? (
                    <OwBadge title={"consignment"} bgColor={"bg-primary text-dark"} leftIconClass={"fad fa-hands-holding-dollar"} />
                ) : null}
                {options.row.is_noninventory_order ? <OwBadge title={"non_inventory"} bgColor={"bg-warning text-dark"} /> : null}
                {options.row.is_quote && options.row.quote_status_id === QuoteStatusEnum.CLOSED ? (
                    <OwBadge title={"closed"} bgColor={"bg-warning text-dark"} />
                ) : null}
                {options.row.order_source_id !== OrderSourceEnum.ORDERWERKS || !!options.row.cart_id ? (
                    <IntegrationsConnectedBar
                        position={"left"}
                        shopifyConnected={options.row.order_source_id === OrderSourceEnum.SHOPIFY}
                        wooCommerceConnected={options.row.order_source_id === OrderSourceEnum.WOOCOMMERCE}
                        openCartConnected={options.row.order_source_id === OrderSourceEnum.OPENCART}
                        appConnected={options.row.order_source_id === OrderSourceEnum.APP}
                        otherConnected={options.row.order_source_id === OrderSourceEnum.OTHER}
                        wayfairConnected={options.row.order_source_id === OrderSourceEnum.WAYFAIR}
                        ecommConnected={options.row.order_source_id === OrderSourceEnum.ORDERWERKS_CART}
                        catchwerksConnected={options.row.order_source_id === OrderSourceEnum.CATCHWERKS}
                        supplierModel={options.supplierModel}
                        showIntegrations={{
                            shopify: options.row.order_source_id === OrderSourceEnum.SHOPIFY,
                            wooCommerce: options.row.order_source_id === OrderSourceEnum.WOOCOMMERCE,
                            opencart: options.row.order_source_id === OrderSourceEnum.OPENCART,
                            other: options.row.order_source_id === OrderSourceEnum.OTHER,
                            app: options.row.order_source_id === OrderSourceEnum.APP,
                            wayfair: options.row.order_source_id === OrderSourceEnum.WAYFAIR,
                            quickbooksDesktop: false,
                            quickbooksOnline: false,
                            shipstation: false,
                            square: false,
                            zoho: false,
                            ecommCart: options.row.order_source_id === OrderSourceEnum.ORDERWERKS_CART,
                            catchwerks: options.row.order_source_id === OrderSourceEnum.CATCHWERKS,
                        }}
                    />
                ) : null}
                {options.row.qbo_EstimateId ? (
                    <div>
                        <IntegrationsConnectedBar
                            position={"left"}
                            qboConnected={true}
                            supplierModel={options.supplierModel}
                            showIntegrations={{
                                quickbooksOnline: true,
                            }}
                        />
                    </div>
                ) : null}
            </div>
            {options.row.wayfair_ack_po ? <OwLabel title={"wayfair_po_acknowledged"} className={"text-success"} /> : null}
            {options.row.order_source_id === OrderSourceEnum.ORDERWERKS && options.row.woocommerce_order_id ? (
                <div className={"text-small text-muted"}>
                    <OwLabel title={"woocommerce_order"} postText={":"} className={"me-2"} />#{options.row.woocommerce_order_id}
                </div>
            ) : null}
            {options.row.shopify_order_name ? (
                <div className={"text-small text-muted"}>
                    <OwLabel title={"shopify_order"} postText={":"} className={"me-2"} />
                    {options.row.shopify_order_name}
                </div>
            ) : null}
            {options.row.Tags?.map((tag: ITag) => {
                return <OwBadge key={tag.id} title={tag.name} bgColor={"bg-primary"} skipTranslate={true} />;
            })}
            {showCreateShipmentBtn ? (
                <OwButton
                    title={"create_shipment"}
                    fn={() => {
                        options.openShipmentSidebar(options.row);
                    }}
                />
            ) : null}
        </div>
    );
};

const workflowRenderFn = (row: IOrder) => {
    return row.Workflow?.name;
};

const warehouseRenderFn = (row: IOrder) => {
    return row.Shipping_Warehouse?.name;
};

const renderOrderCategoryFn = (row: IOrder) => {
    return row.Category?.name;
};

const dateRenderFn = (dateStr: string): string => {
    const parsedDate = UserService.parseDate(dateStr);

    if (parsedDate === "Invalid date") {
        return "";
    } else {
        return parsedDate;
    }
};

// For calendar dates stored as UTC midnight (e.g. delivery_date): render the stored date as-is
// instead of shifting it into the user's timezone, which would show the previous day in the US.
const utcDateRenderFn = (dateStr: string): string => {
    const parsedDate = UserService.parseUTCDate(dateStr);

    if (parsedDate === "Invalid date") {
        return "";
    } else {
        return parsedDate;
    }
};

const estimatedShipDateRenderFn = (row: IOrder): any => {
    const estimatedShipDate = UserService.parseDate(row.estimated_shipping_at);

    if (estimatedShipDate === "Invalid date") {
        return "";
    } else {
        return estimatedShipDate;
    }
};

const getDeceasedDateCol = (options: { is_quotes: boolean | undefined; supplierModel: ISupplierModel }): IOwTableCols | null => {
    if (options.is_quotes) {
        return null;
    }

    if (options.supplierModel && _.isNil(options.supplierModel.settings)) {
        return null;
    }

    if (!options.supplierModel) {
        return null;
    }

    const settings: ISupplierSettings = JSON.parse(JSON.stringify(options.supplierModel.settings));

    if (!settings.order_details) {
        return null;
    } else {
        let hasDeceasedDate = false;

        for (const detail of settings.order_details) {
            if (detail === "deceased_date") {
                hasDeceasedDate = true;
            }
        }

        if (!hasDeceasedDate) {
            return null;
        }

        return {
            title: "deceased_date",
            valueProp: "Order_Detail",
            valueSubProp: "deceased_date",
        };
    }
};

const getDeceasedFirstNameCol = (options: { is_quotes: boolean | undefined; supplierModel: ISupplierModel }): IOwTableCols | null => {
    if (options.is_quotes) {
        return null;
    }

    if (options.supplierModel && _.isNil(options.supplierModel.settings)) {
        return null;
    }

    if (!options.supplierModel) {
        return null;
    }

    const settings: ISupplierSettings = JSON.parse(JSON.stringify(options.supplierModel.settings));

    if (!settings.order_details) {
        return null;
    } else {
        let hasDeceasedFirstName = false;

        for (const detail of settings.order_details) {
            if (detail === "deceased_first_name") {
                hasDeceasedFirstName = true;
            }
        }

        if (!hasDeceasedFirstName) {
            return null;
        }

        return {
            title: "deceased_first_name",
            valueProp: "Order_Detail",
            valueSubProp: "deceased_first_name",
        };
    }
};

const getDeceasedLastNameCol = (options: { is_quotes: boolean | undefined; supplierModel: ISupplierModel }): IOwTableCols | null => {
    if (options.is_quotes) {
        return null;
    }

    if (options.supplierModel && _.isNil(options.supplierModel.settings)) {
        return null;
    }

    if (!options.supplierModel) {
        return null;
    }

    const settings: ISupplierSettings = JSON.parse(JSON.stringify(options.supplierModel.settings));

    if (!settings.order_details) {
        return null;
    } else {
        let hasDeceasedLastName = false;

        for (const detail of settings.order_details) {
            if (detail === "deceased_last_name") {
                hasDeceasedLastName = true;
            }
        }

        if (!hasDeceasedLastName) {
            return null;
        }

        return {
            title: "deceased_last_name",
            valueProp: "Order_Detail",
            valueSubProp: "deceased_last_name",
        };
    }
};

export const OrdersColService = {
    renderOrderNameFn,
    workflowRenderFn,
    warehouseRenderFn,
    renderOrderCategoryFn,
    dateRenderFn,
    utcDateRenderFn,
    estimatedShipDateRenderFn,
    getDeceasedDateCol,
    getDeceasedFirstNameCol,
    getDeceasedLastNameCol,
};
